import i18next from 'i18next';
import { ErrorBoundary } from '../../ui/ErrorBoundary';
import type { MapErrorBoundaryProps } from './MapErrorBoundary.types';
import styles from './MapErrorBoundary.module.css';

/**
 * Specialized error boundary for map components
 * Provides map-specific error handling and recovery options
 */
export const MapErrorBoundary = ({ children }: MapErrorBoundaryProps) => {
  const handleMapError = (error: Error) => {
    console.error('Map error caught by boundary:', error);

    // Additional map-specific error reporting could be added here
    // e.g., analytics, user feedback, etc.
  };

  const MapErrorFallback = (
    <div className={styles.errorContainer}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={styles.errorIcon}
      >
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
        <circle cx="12" cy="10" r="3" />
      </svg>
      <h3 className={styles.errorTitle}>
        {i18next.t('map.errorBoundary.title')}
      </h3>
      <p className={styles.errorMessage}>
        {i18next.t('map.errorBoundary.message')}
      </p>
      <button
        onClick={() => window.location.reload()}
        className={styles.refreshButton}
      >
        {i18next.t('map.errorBoundary.refreshPage')}
      </button>
    </div>
  );

  return (
    <ErrorBoundary fallback={MapErrorFallback} onError={handleMapError}>
      {children}
    </ErrorBoundary>
  );
};
